import noPhoto from '@propertypal/shared/src/resources/fallbacks/no-photo-icon.png';
import { Property } from '@propertypal/shared/src/types/property';
import { getAgentLogos, getMainImage } from '@propertypal/shared/src/utils/property';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import PropertyPrice from '../property/PropertyPrice';
import {
  AccountLogo,
  Container,
  Content,
  PriceRow,
  PropertyContent,
  PropertyImage,
  TextBox,
  Badge,
  PropertyNoImage,
} from './TopPicks.style';

interface Props {
  properties: Property[];
}

const PropertyBox: FunctionComponent<{ property: Property }> = ({ property }) => {
  const [heroImage] = getMainImage(property);
  const theme = useTheme();
  const accountLogos = getAgentLogos(property);

  return (
    <PropertyContent href={property.path} prefetch={false}>
      <Badge>Top pick</Badge>
      {heroImage ? (
        <PropertyImage src={heroImage} />
      ) : (
        <PropertyNoImage src={noPhoto.src} alt="No photo available" data-testid="no-photo-img" />
      )}

      <TextBox>
        <p>
          <b>{property.displayAddressLine1}</b>, {property.displayAddressLine2}
        </p>

        <PriceRow>
          <PropertyPrice prefixBreak fontSize={30} primaryColor={theme.textDark} price={property.price} />

          {!!accountLogos.length && (
            <AccountLogo
              key={accountLogos[0].url}
              style={{
                backgroundColor: accountLogos[0].backgroundColor,
                backgroundImage: `url(${accountLogos[0].url})`,
              }}
            />
          )}
        </PriceRow>
      </TextBox>
    </PropertyContent>
  );
};

const TopPicks: FunctionComponent<Props> = (props) => {
  return (
    <Container>
      <Content>{props.properties?.map((property) => <PropertyBox property={property} key={property.id} />)}</Content>
    </Container>
  );
};

export default TopPicks;
